import { HotspotPinComponent, HotspotSettings, Vector } from '../../models';
import { emptyDocument, stringToLeanProsemirror } from '../../tip-tap';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

type HotspotSettingsProps = Omit<HotspotSettings, 'title' | 'body'> & { title: string; body: string };

type HotspotPinComponentProps = {
  position?: Vector;
  settings?: Partial<HotspotSettingsProps>;
  diameter?: number;
  order?: string;
  rotation?: number;
  id?: string;
};

export const DEFAULT_DIAMETER = 75;

export function newHotspotPinComponent({
  position = initialPinComponentPosition,
  settings = {},
  diameter = DEFAULT_DIAMETER,
  order = defaultOrder,
  rotation,
  id,
}: HotspotPinComponentProps): HotspotPinComponent {
  return {
    type: 'HOTSPOT',
    id: id || randomId(),
    settings: {
      ...settings,
      fillType: settings.fillType || 'ICON',
      iconFill: settings.iconFill || 'ADD',
      imageFill: settings.imageFill || {
        name: 'demo-image.jpg',
        url: 'https://lh3.googleusercontent.com/QjsbtROFsiGYbXAtGymx8rQaasKbIQ9f1YwUEkJL8fWlmwafNHImcWL5ot-IYZuEaZfG85HQS5bJWufho0kpQmeGG2yodzOiKZ9GTKE=s800',
      },
      textFill: settings.textFill || 'ABC',
      showBody: settings.showBody || false,
      expandDirection: settings.expandDirection || 'AUTO',
      body: settings.body ? stringToLeanProsemirror(settings.body) : emptyDocument(),
      linkedPinComponent: settings.linkedPinComponent,
      movableInInteractiveViewer: settings.movableInInteractiveViewer,
      title: settings.title ? stringToLeanProsemirror(settings.title) : emptyDocument(),
      contentTextColor: settings.contentTextColor,
      backgroundColor: settings.backgroundColor,
    },
    layout: newBox(position, newSize(diameter, diameter), rotation, true),
    order,
  };
}
